export default "/assets/not-active.svg";